var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "dialog-base",
    {
      attrs: {
        visible: _vm.visible,
        title: "Chi tiết phiếu thu trước khi thay đổi",
        size: "xl",
        "show-confirm": false,
        "cancel-text": "Đóng",
        "cancel-type": "danger",
        "use-panel": false,
        "append-to-body": true,
        top: "5vh",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        cancel: _vm.handleClose,
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.isLoading,
              expression: "isLoading",
            },
          ],
        },
        [
          _vm.detailData
            ? _c("div", { staticClass: "sk-panel mb-4" }, [
                _c("div", { staticClass: "sk-panel-head" }, [
                  _c(
                    "div",
                    { staticClass: "sk-panel-icon sk-panel-icon--success" },
                    [_c("i", { staticClass: "el-icon-document" })]
                  ),
                  _c("div", [
                    _c("p", { staticClass: "sk-panel-title" }, [
                      _vm._v(
                        "Mã phiếu thu: " +
                          _vm._s(_vm.detailData.invoiceCode || "—")
                      ),
                    ]),
                    _c("p", { staticClass: "sk-panel-subtitle" }, [
                      _vm._v("\n            Người thao tác: "),
                      _c("strong", [_vm._v(_vm._s(_vm.modifiedByName))]),
                      _vm._v("\n            — Thời gian: "),
                      _c("strong", [
                        _vm._v(
                          _vm._s(_vm._f("formatDateTime")(_vm.modifiedDate))
                        ),
                      ]),
                      _vm._v("\n            — Hành động: "),
                      _c("strong", [_vm._v(_vm._s(_vm.actionLabel))]),
                    ]),
                  ]),
                ]),
              ])
            : _vm._e(),
          _vm.snapshot
            ? _c(
                "el-row",
                { staticClass: "mb-4", attrs: { gutter: 20 } },
                [
                  _c("el-col", { attrs: { span: 6 } }, [
                    _c(
                      "div",
                      {
                        staticClass: "sk-panel sk-panel--flat",
                        staticStyle: {
                          padding: "12px",
                          "text-align": "center",
                          "background-color": "#eff6ff",
                          "border-color": "#bfdbfe",
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              color: "#1e3a8a",
                              "font-size": "13px",
                              "margin-bottom": "4px",
                              "font-weight": "600",
                            },
                          },
                          [_vm._v("Phải thu")]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "tdi-money--bold",
                            staticStyle: {
                              "font-size": "17px",
                              color: "#1e40af",
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm._f("formatCurrencyLocal")(
                                  _vm.snapshot.sumMoney
                                )
                              )
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]),
                  _c("el-col", { attrs: { span: 6 } }, [
                    _c(
                      "div",
                      {
                        staticClass: "sk-panel sk-panel--flat",
                        staticStyle: {
                          padding: "12px",
                          "text-align": "center",
                          "background-color": "#f0fdf4",
                          "border-color": "#bbf7d0",
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              color: "#14532d",
                              "font-size": "13px",
                              "margin-bottom": "4px",
                              "font-weight": "600",
                            },
                          },
                          [_vm._v("Đã thu")]
                        ),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "font-size": "17px",
                              "font-weight": "700",
                              color: "#166534",
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm._f("formatCurrencyLocal")(
                                  _vm.snapshot.collectedMoney
                                )
                              )
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]),
                  _c("el-col", { attrs: { span: 6 } }, [
                    _c(
                      "div",
                      {
                        staticClass: "sk-panel sk-panel--flat",
                        staticStyle: {
                          padding: "12px",
                          "text-align": "center",
                          "background-color": "#fffbeb",
                          "border-color": "#fde68a",
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              color: "#78350f",
                              "font-size": "13px",
                              "margin-bottom": "4px",
                              "font-weight": "600",
                            },
                          },
                          [_vm._v("Thiếu/Thừa phiếu thu trước")]
                        ),
                        _c(
                          "div",
                          {
                            class:
                              (_vm.snapshot.beforeMoney || 0) < 0
                                ? "tdi-money--negative"
                                : "tdi-money--positive",
                            staticStyle: {
                              "font-size": "17px",
                              "font-weight": "700",
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm._f("formatCurrencyLocal")(
                                    _vm.snapshot.beforeMoney
                                  )
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]),
                  _c("el-col", { attrs: { span: 6 } }, [
                    _c(
                      "div",
                      {
                        staticClass: "sk-panel sk-panel--flat",
                        staticStyle: {
                          padding: "12px",
                          "text-align": "center",
                          "background-color": "#fef2f2",
                          "border-color": "#fecaca",
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              color: "#7f1d1d",
                              "font-size": "13px",
                              "margin-bottom": "4px",
                              "font-weight": "600",
                            },
                          },
                          [_vm._v("Thiếu/Thừa còn lại")]
                        ),
                        _c(
                          "div",
                          {
                            class:
                              (_vm.snapshot.afterMoney || 0) < 0
                                ? "tdi-money--negative"
                                : "tdi-money--positive",
                            staticStyle: {
                              "font-size": "17px",
                              "font-weight": "700",
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm._f("formatCurrencyLocal")(
                                    _vm.snapshot.afterMoney
                                  )
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _vm.snapshot &&
          _vm.snapshot.invoiceDetails &&
          _vm.snapshot.invoiceDetails.length > 0
            ? _c(
                "div",
                [
                  _c(
                    "p",
                    {
                      staticStyle: {
                        "font-weight": "600",
                        color: "#1e293b",
                        "margin-bottom": "12px",
                        "font-size": "14px",
                      },
                    },
                    [_vm._v("Chi tiết các khoản thu")]
                  ),
                  _c(
                    "el-table",
                    {
                      staticClass: "sk-table custom-header-table",
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _vm.flattenedDetails,
                        border: "",
                        "cell-style": _vm.cellStyleMethod,
                        "row-key": "rowKey",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { label: "STT", width: "60", align: "center" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function ({ row }) {
                                return [
                                  _c(
                                    "span",
                                    { class: { "child-index": row._isChild } },
                                    [_vm._v(_vm._s(row._displayIndex))]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          706053455
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "Tên khoản thu",
                          "min-width": "200",
                          align: "left",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function ({ row }) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "name-cell",
                                      style: {
                                        paddingLeft: `${
                                          (row._depth || 0) * 24
                                        }px`,
                                      },
                                    },
                                    [
                                      row._hasChildren
                                        ? _c(
                                            "el-button",
                                            {
                                              staticClass: "toggle-btn",
                                              attrs: {
                                                type: "text",
                                                size: "mini",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.toggleExpand(
                                                    row._parentIdx
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("i", {
                                                class: _vm.expandedMap[
                                                  row._parentIdx
                                                ]
                                                  ? "el-icon-arrow-down"
                                                  : "el-icon-arrow-right",
                                              }),
                                            ]
                                          )
                                        : _vm._e(),
                                      _c(
                                        "span",
                                        {
                                          class: {
                                            "parent-name": !row._isChild,
                                            "child-name": row._isChild,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(row.revenueName) +
                                              "\n              "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1104999195
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: { label: "HĐĐT", width: "70", align: "center" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function ({ row }) {
                                return [
                                  _c("el-checkbox", {
                                    attrs: { disabled: "" },
                                    model: {
                                      value: row.issuingElectronicInvoices,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          row,
                                          "issuingElectronicInvoices",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "row.issuingElectronicInvoices",
                                    },
                                  }),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3965031144
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "Đơn vị",
                          prop: "unit",
                          width: "90",
                          align: "center",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function ({ row }) {
                                return [
                                  _c("span", [_vm._v(_vm._s(row.unit || "—"))]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3886586390
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "Số lượng",
                          width: "90",
                          align: "center",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function ({ row }) {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.formatQuantity(row.quantity))
                                    ),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          4183977382
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "Đơn giá",
                          width: "140",
                          align: "right",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function ({ row }) {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("formatCurrency")(row.price)
                                      )
                                    ),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2330372116
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "Giảm giá",
                          width: "130",
                          align: "right",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function ({ row }) {
                                return [
                                  row.discount
                                    ? _c("span", [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm._f("formatCurrency")(
                                                row.discountNumber
                                              )
                                            ) +
                                            "\n              "
                                        ),
                                        row.discountType === "PERCENT"
                                          ? _c(
                                              "span",
                                              { staticClass: "text-muted" },
                                              [_vm._v(" (%)")]
                                            )
                                          : _vm._e(),
                                      ])
                                    : _c(
                                        "span",
                                        { staticClass: "text-muted" },
                                        [_vm._v("—")]
                                      ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          883717726
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "Thành tiền",
                          width: "140",
                          align: "right",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function ({ row }) {
                                return [
                                  _c(
                                    "span",
                                    { staticClass: "tdi-money--bold" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("formatCurrency")(row.amount)
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1600692882
                        ),
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm.snapshot &&
              (!_vm.snapshot.invoiceDetails ||
                _vm.snapshot.invoiceDetails.length === 0)
            ? _c(
                "div",
                [
                  _c("el-empty", {
                    attrs: {
                      description: "Không có khoản thu nào",
                      "image-size": 80,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }